
// User
export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILED = 'FETCH_USER_FAILED';

export const LOGIN_ADMIN_USER_REQUEST = 'LOGIN_ADMIN_USER_REQUEST';
export const LOGIN_ADMIN_USER_SUCCESS = 'LOGIN_ADMIN_USER_REQUEST';
export const LOGIN_ADMIN_USER_FAILED = 'LOGIN_ADMIN_USER_REQUEST';

export const FETCH_ALL_USERS_REQUEST = 'FETCH_ALL_USERS_REQUEST';
export const FETCH_ALL_USERS_SUCCESS = 'FETCH_ALL_USERS_SUCCESS';
export const FETCH_ALL_USERS_FAILED = 'FETCH_ALL_USERS_FAILED';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILED = 'DELETE_USER_FAILED';

export const ADD_USER_REQUEST = 'ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILED = 'ADD_USER_FAILED';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'ADD_USER_FAILED';

// Roles
export const FETCH_ROLE_REQUEST = 'FETCH_ROLE_REQUEST';
export const FETCH_ROLE_SUCCESS = 'FETCH_ROLE_SUCCESS';
export const FETCH_ROLE_FAILED = 'FETCH_ROLE_FAILED';

export const FETCH_ALL_ROLES_REQUEST = 'FETCH_ALL_ROLES_REQUEST';
export const FETCH_ALL_ROLES_SUCCESS = 'FETCH_ALL_ROLES_SUCCESS';
export const FETCH_ALL_ROLES_FAILED = 'FETCH_ALL_ROLES_FAILED';

export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILED = 'DELETE_ROLE_FAILED';

export const ADD_ROLE_REQUEST = 'ADD_ROLE_REQUEST';
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const ADD_ROLE_FAILED = 'ADD_ROLE_FAILED';

export const UPDATE_ROLE_REQUEST = 'UPDATE_ROLE_REQUEST';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAILED = 'ADD_ROLE_FAILED';

// Resources
export const FETCH_RESOURCES_REQUEST = 'FETCH_RESOURCES_REQUEST';
export const FETCH_RESOURCES_SUCCESS = 'FETCH_RESOURCES_SUCCESS';
export const FETCH_RESOURCES_FAILED = 'FETCH_RESOURCES_FAILED';

// Diamond
export const FETCH_DIAMOND_USERS_REQUEST = 'FETCH_DIAMOND_USERS_REQUEST';
export const FETCH_DIAMOND_USERS_SUCCESS = 'FETCH_DIAMOND_USERS_SUCCESS';
export const FETCH_DIAMOND_USERS_FAILED = 'FETCH_DIAMOND_USERS_FAILED';

export const FETCH_CUSTOMER_CATEGORIES_REQUEST = 'FETCH_CUSTOMER_CATEGORIES_REQUEST';
export const FETCH_CUSTOMER_CATEGORIES_SUCCESS = 'FETCH_CUSTOMER_CATEGORIES_SUCCESS';
export const FETCH_CUSTOMER_CATEGORIES_FAILED = 'FETCH_CUSTOMER_CATEGORIES_FAILED';

// Category
export const FETCH_CATEGORY_ALL_REQUEST = 'FETCH_CATEGORY_ALL_REQUEST';
export const FETCH_CATEGORY_ALL_SUCCESS = 'FETCH_CATEGORY_ALL_SUCCESS';
export const FETCH_CATEGORY_ALL_FAILED = 'FETCH_CATEGORY_ALL_FAILED';

export const FETCH_CATEGORY_REQUEST = 'FETCH_CATEGORY_REQUEST';
export const FETCH_CATEGORY_SUCCESS = 'FETCH_CATEGORY_SUCCESS';
export const FETCH_CATEGORY_FAILED = 'FETCH_CATEGORY_FAILED';

export const FETCH_ARTICLE_REQUEST = 'FETCH_ARTICLE_REQUEST';
export const FETCH_ARTICLE_SUCCESS = 'FETCH_ARTICLE_SUCCESS';
export const FETCH_ARTICLE_FAILED = 'FETCH_ARTICLE_FAILED';

export const FETCH_ARTICLE_COLORS_REQUEST = 'FETCH_ARTICLE_COLORS_REQUEST';
export const FETCH_ARTICLE_COLORS_SUCCESS = 'FETCH_ARTICLE_COLORS_SUCCESS';
export const FETCH_ARTICLE_COLORS_FAILED = 'FETCH_ARTICLE_COLORS_FAILED';

export const FETCH_ARTICLE_SIZES_REQUEST = 'FETCH_ARTICLE_SIZES_REQUEST';
export const FETCH_ARTICLE_SIZES_SUCCESS = 'FETCH_ARTICLE_SIZES_SUCCESS';
export const FETCH_ARTICLE_SIZES_FAILED = 'FETCH_ARTICLE_SIZES_FAILED';

export const FETCH_NAVITEMS_REQUEST = 'FETCH_NAVITEMS_REQUEST';
export const FETCH_NAVITEMS_SUCCESS = 'FETCH_NAVITEMS_SUCCESS';
export const FETCH_NAVITEMS_FAILED = 'FETCH_NAVITEMS_FAILED';

export const FETCH_FOOTERITEMS_REQUEST = 'FETCH_FOOTERITEMS_REQUEST';
export const FETCH_FOOTERITEMS_SUCCESS = 'FETCH_FOOTERITEMS_SUCCESS';
export const FETCH_FOOTERITEMS_FAILED = 'FETCH_FOOTERITEMS_FAILED';

export const FETCH_CURRENT_USER_REQUEST = 'FETCH_CURRENT_USER_REQUEST';
export const FETCH_CURRENT_USER_SUCCESS = 'FETCH_CURRENT_USER_SUCCESS';
export const FETCH_CURRENT_USER_FAILED = 'FETCH_CURRENT_USER_FAILED';

export const SET_SELECTED_COLOR = 'SET_SELECTED_COLOR';
export const SET_SELECTED_SIZE = 'SET_SELECTED_SIZE';

export const SET_ERRORS = 'SET_ERRORS';

export const FETCH_CART_REQUEST = 'FETCH_CART_REQUEST';
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS';
export const FETCH_CART_FAILED = 'FETCH_CART_FAILED';

export const ADD_MODAL = 'ADD_MODAL';
export const REMOVE_MODAL = 'REMOVE_MODAL';

export const FETCH_FAVORITES_REQUEST = 'FETCH_FAVORITES_REQUEST';
export const FETCH_FAVORITES_SUCCESS = 'FETCH_FAVORITES_SUCCESS';
export const FETCH_FAVORITES_FAILED = 'FETCH_FAVORITES_FAILED';

export const ADD_CART_ITEM_REQUEST = 'ADD_CART_ITEM_REQUEST';
export const ADD_CART_ITEM_SUCCESS = 'ADD_CART_ITEM_SUCCESS';
export const ADD_CART_ITEM_FAILED = 'ADD_CART_ITEM_FAILED';

export const ADD_FAVORITE_REQUEST = 'ADD_FAVORITE_REQUEST';
export const ADD_FAVORITE_SUCCESS = 'ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_FAILED = 'ADD_FAVORITE_FAILED';

export const REMOVE_FAVORITE_REQUEST = 'REMOVE_FAVORITE_REQUEST';
export const REMOVE_FAVORITE_SUCCESS = 'REMOVE_FAVORITE_SUCCESS';
export const REMOVE_FAVORITE_FAILED = 'REMOVE_FAVORITE_FAILED';

export const UPDATE_CART_ITEM_REQUEST = 'UPDATE_CART_ITEM_REQUEST';
export const UPDATE_CART_ITEM_SUCCESS = 'UPDATE_CART_ITEM_SUCCESS';
export const UPDATE_CART_ITEM_FAILED = 'UPDATE_CART_ITEM_FAILED';

export const DELETE_CART_ITEM_REQUEST = 'DELETE_CART_ITEM_REQUEST';
export const DELETE_CART_ITEM_SUCCESS = 'DELETE_CART_ITEM_SUCCESS';
export const DELETE_CART_ITEM_FAILED = 'DELETE_CART_ITEM_FAILED';

export const FETCH_SAMPLE_REQUEST = 'FETCH_SAMPLE_REQUEST';
export const FETCH_SAMPLE_SUCCESS = 'FETCH_SAMPLE_SUCCESS';
export const FETCH_SAMPLE_FAILED = 'FETCH_SAMPLE_FAILED';

export const ADD_SAMPLE_ITEM_REQUEST = 'ADD_SAMPLE_ITEM_REQUEST';
export const ADD_SAMPLE_ITEM_SUCCESS = 'ADD_SAMPLE_ITEM_SUCCESS';
export const ADD_SAMPLE_ITEM_FAILED = 'ADD_SAMPLE_ITEM_FAILED';

export const UPDATE_SAMPLE_ITEM_REQUEST = 'UPDATE_SAMPLE_ITEM_REQUEST';
export const UPDATE_SAMPLE_ITEM_SUCCESS = 'UPDATE_SAMPLE_ITEM_SUCCESS';
export const UPDATE_SAMPLE_ITEM_FAILED = 'UPDATE_SAMPLE_ITEM_FAILED';

export const DELETE_SAMPLE_ITEM_REQUEST = 'DELETE_SAMPLE_ITEM_REQUEST';
export const DELETE_SAMPLE_ITEM_SUCCESS = 'DELETE_SAMPLE_ITEM_SUCCESS';
export const DELETE_SAMPLE_ITEM_FAILED = 'DELETE_SAMPLE_ITEM_FAILED';